module.exports = __webpack_public_path__ + "static/media/Queues.437d7747.webp";